import React from 'react';
import PropTypes from 'prop-types';
import FilterDropDownList from '../filter-dropdownlist';
import CourseName from '../course-name';
import css from './filter-bar.scss';

const ShowFilter = (props) => {
  const { i18n, isOpen, onApply } = props;
  if (!isOpen) return null;
  return (
    <div className={css.search} data-testid="show-filter">
      <CourseName i18n={i18n} />
      <FilterDropDownList i18n={i18n} onApply={onApply} />
    </div>
  );
};

ShowFilter.propTypes = {
  i18n: PropTypes.object,
  isOpen: PropTypes.bool,
  onApply: PropTypes.func
};

ShowFilter.isOpen = false;

export default ShowFilter;



// WEBPACK FOOTER //
// ./components/filter-bar/show-filter.js